import React, { FC } from 'react';
import classnames from 'classnames';
import Svg from 'svg-inline-react';
import { Markdown } from '@src/components/Markdown';
import { TypingLoader } from '@src/components/TypingLoader';
import { TypingLoaderType } from '@src/components/TypingLoader/enums/TypingLoaderType.enum';
import FrankLogoSvg from '@src/svgs/frank-logo-new.svg';
import { HighlightBoxProps } from './props';
import './styles.scss';

export const HighlightBox: FC<HighlightBoxProps> = ({ text, timestamp, isDense, isLoading }) => {
  return (
    <div className={classnames('highlight-box', (isDense || isLoading) && 'highlight-box--dense')}>
      <div className={classnames('highlight-box__loading', !isLoading && 'highlight-box__loading--hide')}>
        <TypingLoader type={TypingLoaderType.LIGHT} />
      </div>

      <div className={classnames('highlight-box__content', !isLoading && 'highlight-box__content--show')}>
        <div className={classnames('highlight-box__dense-text', !!isDense && 'highlight-box__dense-text--show')}>
          <div className="highlight-box__text highlight-box__text--dense">{text}</div>
        </div>

        <div className={classnames('highlight-box__full-text', !isDense && 'highlight-box__full-text--show')}>
          <div className="highlight-box__full-text-header">
            <h3 className="highlight-box__title">I'm looking for</h3>

            {timestamp && <h3 className="highlight-box__timestamp">{timestamp}</h3>}

            <Svg className="highlight-box__frank" src={FrankLogoSvg} />
          </div>

          <Markdown markdown={text} wrapperClassName="highlight-box__text" />
        </div>
      </div>
    </div>
  );
};
